<template>
  <div class="searchBar">
    <div class="divInput">
      <input type="text" :placeholder="$t('searchBar.placeholder')" @focus="onFocus" @blur="onBlur" :value="searchText" @input="e => searchText = e.target.value" @keydown.enter="search"
        class="search" />
      <div v-show="focused && this.searchText && products.slice(0, 4).length" class="optionAutoComplete">
        <div class="autocompleteContainer">
          <autocomplete-result :key="product.identifier" :searchText="searchText" :product="product" :query="searchText" v-for="product in products.slice(0, 4)" />
        </div>
      </div>
    </div>
    <button v-show="searchText.length > 0" class="reset" @click="resetSearch"></button>
    <button @click="search">
      <svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" style="height: 1em; width: auto;">
        <path
          d="M11.8125 11.5391L8.67188 8.39844C9.35156 7.57812 9.72656 6.52344 9.72656 5.375C9.72656 2.70312 7.52344 0.5 4.85156 0.5C2.15625 0.5 0 2.70312 0 5.375C0 8.07031 2.17969 10.25 4.85156 10.25C5.97656 10.25 7.03125 9.875 7.875 9.19531L11.0156 12.3359C11.1328 12.4531 11.2734 12.5 11.4375 12.5C11.5781 12.5 11.7188 12.4531 11.8125 12.3359C12.0469 12.125 12.0469 11.7734 11.8125 11.5391ZM1.125 5.375C1.125 3.3125 2.78906 1.625 4.875 1.625C6.9375 1.625 8.625 3.3125 8.625 5.375C8.625 7.46094 6.9375 9.125 4.875 9.125C2.78906 9.125 1.125 7.46094 1.125 5.375Z"
          fill="#2A2A2A" />
      </svg>
    </button>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import AutocompleteResult from '@/components/Search/AutocompleteResult.vue';
import { mapGetters } from 'vuex';
import hashMixins from '@/hashMixins';

export default {
  components: {
    AutocompleteResult
  },
  data() {
    return {
      hrefQueryString: location.href.includes('?') ? location.href.substring(location.href.indexOf('?'), location.href.indexOf('#')) : null,
      resultsPageName: location.href.includes('?') ? `resultats-de-recherche${location.href.substring(location.href.indexOf('?'), location.href.indexOf('#'))}` : 'resultats-de-recherche',
      searchText: '',
      selectedCategory: null,
      focused: false
    };
  },
  computed: {
    ...mapGetters('searchModule', ['products']),
    currentStore() {
      return this.$root.getStore();
    }
  },
  async created() {
    this.setSearchTextWithHashParam();
  },
  async mounted() {
    const btnMenu = document.getElementById('btnMenu');

    if (btnMenu) {
      btnMenu.addEventListener('click', () => {
        this.resetSearch();
        this.closeSearch();
      });
    }
  },
  methods: {
    async autocomplete() {
      let params = {
        count: 4,
        isDesc: true,
        search: encodeURIComponent(this.searchText),
        sort: 5,
        store: this.currentStore
      };

      if (this.selectedCategory) {
        params.majorCategory = this.selectedCategory;
      }
      if (this.currentStore) {
        params.store = this.currentStore;
      }

      if (this.searchText && this.searchText.trim()) {
        await this.$root.ensureHiddenCategoriesAreLoaded();

        const response = await this.$root.sendAppSearchRequest({
          facets: this.$root.getAppSearchFacets(),
          filters: this.$root.getAppSearchFilters(),
          page: {
            current: 1,
            size: 4
          },
          query: this.searchText
        });
        await this.$store.dispatch('searchModule/setProducts', { products: response.results, selectedStore: this.$root.getStore() });
      } else {
        await this.$store.dispatch('searchModule/resetProducts');
      }
    },
    onFocus() {
      this.focused = true;
    },
    onBlur(e) {
      if (e.relatedTarget === null || !e.relatedTarget.innerHTML.includes('resultContent')) {
        this.focused = false;
      }
    },
    resetSearch() {
      this.searchText = '';
      this.$store.dispatch('searchModule/resetProducts');
    },
    getHashString(query) {
      return query.hasOwnProperty('category') && query.category !== null
        ? `${this.resultsPageName}#q=${query.text}&category=${query.category}`
        : `${this.resultsPageName}#q=${query.text}`;
    },
    search() {
      if (this.searchText) {
        const hashString = this.getHashString({
          text: encodeURIComponent(this.searchText)
        });

        location.href = `${location.origin}/${hashString}`;

        // On force le reload de la page quand on est sur la même page
        // à cause du hash (« # »)

        if (location.pathname === `/${this.resultsPageName}` || `${location.pathname}${this.hrefQueryString}` === `/${this.resultsPageName}`) {
          location.reload();
        }
      }
    },
    setSearchTextWithHashParam() {
      const hashParams = this.getHashParams();
      const searchText = hashParams['q'];
      if (searchText) {
        this.searchText = searchText;
      }
    },
    closeSearch() {
      const search = document.getElementById('searchMobile');
      if (search) {
        search.classList.remove('open');
      }
    }
  },
  watch: {
    searchText: debounce(function () {
      this.autocomplete();
    }, 300),
    selectedCategory() {
      this.autocomplete();
    }
  },
  mixins: [hashMixins]
};
</script>
